export default "<p>\r\n  menu-pedido works!\r\n</p>\r\n";